import * as React from 'react';
import { Box, BoxProps } from './Box';

type SeparatorProps = BoxProps;

export const Separator = (props: SeparatorProps) => {
  return (
    <Box
      as="hr"
      variant="default"
      {...props}
      // @ts-ignore
      __themeKey="separators"
    />
  );
};
